var AppStatus;
(function(AppStatus2) {
  AppStatus2["UPCOMING"] = "upcoming";
  AppStatus2["PREMIUM"] = "premium";
  AppStatus2["BETA"] = "beta";
  AppStatus2["FEATURED"] = "featured";
})(AppStatus || (AppStatus = {}));

export { AppStatus };
//# sourceMappingURL=types.es.js.map
